import { priceBookIdFormat } from "@redotech/redo-ids-cockroach";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deletePriceBook = unaryRpc({
  name: "deletePriceBook" as const,
  input: z.object({ priceBookId: priceBookIdFormat.schema }),
  output: z.object({}),
});
